var redefine = require('../internals/redefine');

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/redefine-all.js
// module id = 513
// module chunks = 1